/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadPartiesDetails(partiesList) {
  return await api
    .post(`/org/getpurchaseorder`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDashboardTransactionsDetails(transactionsList) {
  return await api
    .post(`/org/getdashboardtransaction`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadTotalBalanceDetails(transactionsList) {
  return await api
    .post(`/org/gettotalbalance`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartiesDetails(partiesList) {
  return await api
    .post(`/org/createpurchaseorder`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//party vendor address
export async function loadPartyVendorAddressDetails(addressList) {
  return await api
    .post(`/org/getpartyorvendoraddress`, addressList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartyVendorAddressDetails(partyAddress) {
  return await api
    .post(`/org/addpartyorvendorshippingaddress`, partyAddress)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesCategoryDetails(partiesList) {
  return await api
    .post(`/org/getpartycategory`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartiesCategoryDetails(partiesList) {
  return await api
    .post(`/org/createpartycategory`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function updatePartiesDetails(partiesList) {
  return await api
    .put(`/org/updatepurchaseorder`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deletePartiesDetails(partiesList) {
  return await api
    .post(`/org/deletepurchaseorder`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesTransactionDetails(partiesList) {
  return await api
    .post(`/org/getpartytransaction`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}


const remotes = {
  loadPartiesDetails,
  loadPartyVendorAddressDetails,
  createPartyVendorAddressDetails,
  loadPartiesTransactionDetails,
  createPartiesDetails,
  loadRecordsMetaData,
  updatePartiesDetails,
  deletePartiesDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadDashboardTransactionsDetails,
  loadTotalBalanceDetails
};

export default remotes;
